import React from "react";
import styles from "./chat.module.css";
import { AiOutlineUser, AiOutlineLeft, AiOutlineSend } from "react-icons/ai";

import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import Message from "./Message";
import useChat from './useChat'

const Chat = (props) => {
  const history = useHistory();
  const { roomId } = props.match.params;
  const { messages, sendMessage } = useChat(roomId);
  const [newMessage, setNewMessage] = React.useState("");

  const handleNewMessageChange = (event) => {
    setNewMessage(event.target.value);
  };

  const handleSendMessage = () => {
    sendMessage(newMessage);
    setNewMessage("");
  };

console.log(messages)

  return (
    <section className={styles.chatWrapper}>
      <div className={styles.chatApp}>
        <header className={styles.chatHeader}>
          <div className={styles.chatProfile}>
            <div className={styles.chatImage}>
              <AiOutlineUser size={32} color="#7c3aed" />
            </div>
            <div className={styles.chatName}>
              <h4>مهدی بهرامی</h4>
            </div>
          </div>

          <div className={styles.backButton} onClick={() => history.goBack()}>
            <AiOutlineLeft size={32} color="#7c3aed" />
          </div>
        </header>

        <div className={styles.chatBody}>
          {messages.map((msg , i) => (
            <Message key={i} message={msg} />
          ))}
        </div>

        <div className={styles.chatFooter}>
          <input placeholder="پیام خود را تایپ کنید..." name="message" value={newMessage} onChange={handleNewMessageChange} />
          <button onClick={handleSendMessage}>
            <AiOutlineSend
              size={32}
              color="#7c3aed"
              className={styles.sentIcon}
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Chat;
